import React from 'react'
import ButtonClose from '../../atoms/button-close/button-close'
import Button from '../../atoms/button/button'

import menstruacion from '../../../assets/images/games/personajes/menstruacion-end-game-mb.png'
import pubertad from '../../../assets/images/games/personajes/pubertad-end-game-mb.png'
import zonaV from '../../../assets/images/games/personajes/zona-v-end-game-mb.png'

import menstruacionPC from '../../../assets/images/games/personajes/menstruacion@2x.png'
import pubertadPC from '../../../assets/images/games/personajes/pubertad@2x.png'
import zonaVPC from '../../../assets/images/games/personajes/zona-v@2x.png'

import './modalEndGame.scss'
import useMediaQuery from '../../../utils/useMediaQuery'
import getUserInfo from '../../../utils/getUserInfo'
import { pushEventData } from '../../../utils/pushEventDataLayer'
import { jsonToHash } from '../../../utils/crypto'
import { useEffect } from 'react'
import { requestPoints } from '../../organisms/game-content/levelData'
import { useState } from 'react'
import { datesFaseActivities } from '../../../constants/activity-constants'

import { LOCALE } from '../../../constants/activity-constants'

const arg = LOCALE === "es-AR"

const imgByGameType = {
  mobile: {
    tetris: pubertad,
    snake: menstruacion,
    linea3: zonaV,
  },
  pc: {
    tetris: pubertadPC,
    snake: menstruacionPC,
    linea3: zonaVPC,
  },
}

const pushGameMetric = async (gametype, action, label) => {
  const userInfo = getUserInfo()
  if (!userInfo) {
    return false
  }

  const category = {
    snake: 'Planeta_Menstruacion',
    tetris: 'Planeta_Pubertad',
    linea3: 'Planeta_ZonaV',
  }[gametype]
  pushEventData({
    event: 'Interacciones_juego_UCole',
    category,
    action,
    label,
    user_data: [
      await jsonToHash({
        nombre: userInfo.name,
        apellido: userInfo.lastName,
        celular: userInfo.cellPhone,
        correo: userInfo.email,
        ciudad: userInfo.location.cityName,
        departamento: userInfo.location.countryStateName,
        pais: userInfo.countryName,
      }),
    ],
    log_status: 'Yes',
  })
  return true
}
const ModalEndGame = ({
  gametype,
  win = false,
  points = 0,
  onConfirm,
  onCancel,
}) => {
   
  const [totalpoints, setTotalPoints] = useState()
  const device = useMediaQuery() ? 'mobile' : 'pc'
  let title =
    {
      snake: '¡Ups!',
    }[gametype] || '¡Se te acabó el tiempo!'

  const callToAction = e => {
    pushGameMetric(gametype, 'click', e.target.innerText)
    onConfirm && onConfirm()
  }

  useEffect(() => {
    requestPoints(['tetris', 'snake', 'linea3']).then(total_points => {
      setTotalPoints(total_points) 
    })
    pushGameMetric(gametype, 'view', title)
  })
  return (
    <div className={'f-modal-end-game ' + ('--' + gametype)}>
      <div className="f-modal-end-game__card">
        <ButtonClose onClick={onCancel} />

        <div className="f-modal-end-game__card__body">
          <figure className="--main">
            <img src={imgByGameType[device][gametype]} alt="personaje" />
          </figure>
          <aside className="--evenly-colum">
            <h2
              className={'f-modal-end-game__card__title ' + ('--' + gametype)}
            >
              {win ? '!WOW!' : title}
            </h2>
            <p className="--text-center">Lograste</p>
            <h2 className="f-modal-end-game__card__title --t25">
              {points} Puntos
            </h2>
            <br />
            <p className="--text-center --bold-high">
              {arg ? '¡Llevás' : '¡Llevas'} <b className="--accent">{totalpoints}</b> puntos en total!
            </p>
            <p className="--text-center">
              <br />
              {arg ? 'Seguí' : 'Sigue'} jugando para que estés
              <br /> en el top de jugadoras.
            </p>
            <br />
            <Button title="Volver a jugar" onClick={callToAction}>
              Volver a jugar
            </Button>
          </aside>
        </div>
      </div>
    </div>
  )
}

export default ModalEndGame
